






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ComponentProps, Locations } from './types';
import { yandexMap, ymapMarker } from 'vue-yandex-maps';

const DEFAULT_COORDS = [55.753215, 37.622504];
const MAX_ZOOM = 18;

@Component({
  components: {
    yandexMap,
    ymapMarker,
  },
})
export default class ComponentsPartsCatalogCardComponentsTabsPlace extends Vue
  implements ComponentProps {
  // Props
  @Prop({ type: String, default: 'Пройти тест' })
  title: string;

  @Prop({ type: Array, default: () => [] })
  geo: Locations;

  public mapInstance: any = null;
  public currentZoom: number = 12;
  public cashedCoords: Array<number> = DEFAULT_COORDS;

  get coords(): Array<number> {
    return DEFAULT_COORDS;
  }

  onMapInitialized(mapInstance: any) {
    this.mapInstance = mapInstance;
    this.mapInstance.options.set('maxZoom', MAX_ZOOM);
    const bounds = mapInstance.geoObjects.getBounds();
    if (bounds) {
      mapInstance
        .setBounds(bounds, {
          checkZoomRange: true,
          useMapMargin: true,
          zoomMargin: [15, 15, 15, 15],
        })
        .then(() => {
          if (mapInstance.getZoom() > MAX_ZOOM) {
            mapInstance.setZoom(MAX_ZOOM);
          }
          this.currentZoom = mapInstance.getZoom();
          this.cashedCoords = mapInstance.getCenter();
        })
        .catch((err: any) => console.error(err));
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/card/components/tabs/place/Place.vue